import React from "react"
import "./video.css"
const Video = ({ videoSrcURL, videoTitle, ...props }) => (
  <div className="video" style={props.style}>
    <iframe
        style={{width:'100%', height: '100%'}}
      src={videoSrcURL}
      title={videoTitle}
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      frameBorder="0"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
      allowFullScreen
    />
  </div>
)
export default Video
